import { render, staticRenderFns } from "./event-upsert-form-items.vue?vue&type=template&id=e6a1e7ae&"
import script from "./event-upsert-form-items.vue?vue&type=script&lang=ts&"
export * from "./event-upsert-form-items.vue?vue&type=script&lang=ts&"
import style0 from "./event-upsert-form-items.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports